import {ApptSlot} from "../_services/monolith/availability";
import {MsMap} from "../constants/MsMap";

const SLOT_COUNT_THRESHOLD = 4;
const TWO_HOURS = MsMap.ONE_HOUR * 2;
const SLOT_TIME_THRESHOLD = TWO_HOURS;

/**
 * @param ignore2HrRule One condition for flagging limited availability is if there are no slots within two hours.
 * This is irrelevant when looking at a list of slots on a day that isn't today because there is no relative time
 * to count from. Set this flag to true if the slot set is from a future day.
 */
export const hasLimitedAvailability = (slots?: ApptSlot[], ignore2HrRule = false): boolean => {
  // slot count rule: There must be fewer than 4 slots
  if (!slots || slots.length < SLOT_COUNT_THRESHOLD) return true;

  // two hour rule: There should not be any slots within two hours as long as not `ignore2HrRule`
  return !ignore2HrRule && slots[0]?.time - Date.now() >= SLOT_TIME_THRESHOLD;
};
